const ROOT = 'communities-welcome-onboarding' as const

/**
 * Peer-aligned key factory (content-moderation / skool-import):
 * `all` is a true prefix of `setup` / `member` so invalidateQueries({ queryKey: all(...) }) works.
 */
export function createWelcomeOnboardingAllQueryKey(locationId?: string, groupId?: string): readonly unknown[] {
  return [ROOT, locationId, groupId] as const
}

export function createWelcomeSetupQueryKey(locationId?: string, groupId?: string): readonly unknown[] {
  return [ROOT, locationId, groupId, 'setup'] as const
}

export function createMemberOnboardingQueryKey(locationId?: string, groupId?: string): readonly unknown[] {
  return [ROOT, locationId, groupId, 'member'] as const
}

export const welcomeOnboardingQueryKeys = {
  all: createWelcomeOnboardingAllQueryKey,
  setup: createWelcomeSetupQueryKey,
  member: createMemberOnboardingQueryKey,
} as const
